export enum UserRoles {
  AGENT = 'agent',
  NONE_SALES_AGENT = 'non-sales-agent',
  BRANCH_MANAGER = 'branch-manager',
  MARKETING_DIRECTOR = 'marketing-director',
  NATIONAL_DIRECTOR = 'national-director',
  LCC = 'lcc',
  LCC_MANAGER = 'lcc-manager',
  LCC_NATIONAL_DIRECTOR = 'lcc-national-director',
  CBR_NATIONAL_DIRECTOR = 'cbr-national-director',
  CBA_NATIONAL_DIRECTOR = 'cba-national-director',
  ERA_NATIONAL_DIRECTOR = 'era-national-director',
  BHG_NATIONAL_DIRECTOR = 'bhg-national-director',
  C21_NATIONAL_DIRECTOR = 'c21-national-director',
  CMP_NATIONAL_DIRECTOR = 'cmp-national-director',
  DELEGATE = 'delegate',
  AGENT_PROFILE = 'agent-profile',
}

export const UserRolesDisplays: { key: UserRoles, value: string }[] = [
  { key: UserRoles.AGENT, value: 'Agent' },
  { key: UserRoles.NONE_SALES_AGENT, value: 'Non-sales Agent' },
  { key: UserRoles.BRANCH_MANAGER, value: 'Branch Manager' },
  { key: UserRoles.MARKETING_DIRECTOR, value: 'Marketing Director' },
  { key: UserRoles.NATIONAL_DIRECTOR, value: 'National Director' },
  { key: UserRoles.LCC, value: 'LCC' },
  { key: UserRoles.DELEGATE, value: 'Delegate' },
  { key: UserRoles.LCC_MANAGER, value: 'LCC Manager' },
  { key: UserRoles.LCC_NATIONAL_DIRECTOR, value: 'LCC National Director' },
  { key: UserRoles.CBR_NATIONAL_DIRECTOR, value: 'National CBR Director' },
  { key: UserRoles.CBA_NATIONAL_DIRECTOR, value: 'National CBA Director' },
  { key: UserRoles.ERA_NATIONAL_DIRECTOR, value: 'National ERA Director' },
  { key: UserRoles.BHG_NATIONAL_DIRECTOR, value: 'National BHGRE Director' },
  { key: UserRoles.C21_NATIONAL_DIRECTOR, value: 'National C21 Director' },
  { key: UserRoles.CMP_NATIONAL_DIRECTOR, value: 'National Compass OBO' },
];
